import type { IconProps } from '../types/IconProps.ts';
export const Bookmark: IconProps = {
    name: 'Bookmark',
    children: [
        `<path d="M5 4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v16.23a1 1 0 0 1-1.52.86l-4.96-3a1 1 0 0 0-1.04 0l-4.96 3A1 1 0 0 1 5 20.23z" />`,
    ]
};